(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fairy-offer"] && !Shopify.designMode) return;
  try {
    function fairyWeekWindow(now){const fmt=new Intl.DateTimeFormat('en-US',{timeZone:'America/Chicago',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',minute:'numeric',second:'numeric',hourCycle:'h23'});const parts=Object.fromEntries(fmt.formatToParts(now).map(p=>[p.type,p.value]));const y=+parts.year,m=+parts.month,d=+parts.day,h=+parts.hour;const today=new Date(Date.UTC(y,m-1,d));const weekday=today.getUTCDay();const sunday=new Date(Date.UTC(y,m-1,d+(7-weekday)%7,12));const atGuess=Object.fromEntries(fmt.formatToParts(sunday).map(p=>[p.type,p.value]));const end=sunday.getTime()+(12-Number(atGuess.hour))*3600000;return{active:!(weekday===0&&h>=12),end};}
document.querySelectorAll('.fp-offer').forEach(offer=>{const clock=offer.querySelector('.fp-countdown');const verifiedStart=Date.parse(offer.dataset.start),verifiedEnd=Date.parse(offer.dataset.end);function tick(){const now=new Date();const window=fairyWeekWindow(now);const active=window.active&&Number.isFinite(verifiedStart)&&Number.isFinite(verifiedEnd)&&now.getTime()>=verifiedStart&&now.getTime()<verifiedEnd&&window.end===verifiedEnd;offer.hidden=!active;if(!active)return;const total=Math.max(0,Math.floor((verifiedEnd-now.getTime())/1000));const units={days:Math.floor(total/86400),hours:Math.floor(total/3600)%24,minutes:Math.floor(total/60)%60,seconds:total%60};Object.entries(units).forEach(([name,value])=>offer.querySelector('[data-unit="'+name+'"]').textContent=String(value).padStart(2,'0'));const deadline=offer.querySelector('.fp-weekly-deadline');deadline.dateTime=new Date(window.end).toISOString();deadline.textContent=new Intl.DateTimeFormat('en-US',{timeZone:'America/Chicago',month:'long',day:'numeric',year:'numeric'}).format(window.end);clock.hidden=false;}tick();setInterval(tick,1000);document.addEventListener('visibilitychange',tick);const copy=offer.querySelector('.fp-copy');copy.hidden=false;copy.addEventListener('click',async()=>{const status=offer.querySelector('.fp-copy-status');try{await navigator.clipboard.writeText(offer.querySelector('.fp-offer-code strong').textContent.trim());status.textContent=copy.dataset.copied;}catch(e){status.textContent=copy.dataset.fallback;offer.querySelector('.fp-offer-code strong').focus();}});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fairy-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fairy-size-guide')) {
  customElements.define('fairy-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const trigger = this.querySelector('.fp-size-guide__trigger');
      const dialog = this.querySelector('dialog');
      const close = this.querySelector('.fp-size-guide__close');
      if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
      trigger.hidden = false;
      trigger.addEventListener('click', () => {
        if (dialog.open) return;
        this.previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        close.focus();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        if (trigger.isConnected) trigger.focus();
      });
    }
    disconnectedCallback() {
      if (this.querySelector('dialog')?.open) document.body.style.overflow = this.previousOverflow || '';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
